import React, { useEffect } from 'react';
import { SimpleProduct, WarrantyGroup } from '@msdyn365-commerce/retail-proxy';
import MsDyn365, { ICoreContext } from '@msdyn365-commerce/core';
import { getApplicableWarrantiesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { WarrantySelection } from './WarrantySelection';
import { IHeiBuyboxResources as IBuyboxExtentionResources } from '../../definition-extensions/hei-buybox.ext.props.autogenerated';
import { ICustomWindow } from '../../../../common/utilities/helpers';

const ProductWarranty = ({
    context,
    catalogId,
    productId,
    extentionResources,
    setWarrantySelected
}: {
    context: ICoreContext;
    catalogId: number;
    productId?: number;
    extentionResources: IBuyboxExtentionResources;
    setWarrantySelected: (warrantySelected: boolean) => void;
}) => {
    const [selectedWarranty, setSelectedWarranty] = React.useState<SimpleProduct>();
    const [warrantyGroups, setWarrantyGroups] = React.useState<WarrantyGroup[]>([]);
    useEffect(() => {
        if (productId) {
            (async () => {
                const data = await getApplicableWarrantiesAsync({ callerContext: context.actionContext }, catalogId, [productId]);
                setWarrantyGroups(data[0]?.WarrantyGroups ?? []);
            })();
        }
    }, [catalogId, productId ?? 0]);

    const updateSelectedWarranty = (warranty?: SimpleProduct) => {
        setSelectedWarranty(warranty);
        setWarrantySelected(!!warranty);

        if (MsDyn365.isBrowser) {
            const customWindow: ICustomWindow = window;
            customWindow.__warranty__ = warranty;
        }
    };

    if (warrantyGroups.length > 0) {
        return (
            <WarrantySelection
                warrantyGroups={warrantyGroups}
                formatPriceFn={context.cultureFormatter.formatCurrency}
                selectedWarranty={selectedWarranty?.RecordId ?? 0}
                setSelectedWarranty={updateSelectedWarranty}
                resources={extentionResources}
            />
        );
    }

    return null;
};

export { ProductWarranty };
